import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import LoadingAnimation from '@zr/components/LoadingAnimation';

import QuestionLabel from '../../../components/QuestionLabel';

import UploadResumeModal from './UploadResumeModal';

import './UploadResume.less';

export function UploadResume({
  index, onContinue, onError, onSkip, totalScreeningQuestions,
  isInJs6650Test, setIsLoading,
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading(isUploading);
  }, [isUploading, setIsLoading]);

  const handleUploadStart = () => {
    setIsUploading(true);
  };

  const handleUploadError = () => {
    setIsUploading(false);
    onError();
  };

  const handleContinue = () => {
    onContinue();
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className={`UploadResume ${isInJs6650Test ? 'js6650' : ''}`}>
      {isInJs6650Test && (
        <QuestionLabel
          as="legend"
          html="Please upload your resume."
          number={index}
          totalQuestions={totalScreeningQuestions}
        />
      )}
      {!isInJs6650Test && (
        <h2 className="indexed_header">
          {`${index}. Please upload your resume. `}
          <span className="recommended_highlight">Recommended</span>
        </h2>
      )}
      <p className="description">Hiring managers prefer profiles with a resume on file. Improve your chances by uploading one now.</p>
      {isUploading && (
        <LoadingAnimation loadingMessage="Uploading resume..." />
      )}
      {!isUploading && (
        <div className="buttons_wrapper">
          <button className="open_modal_button" onClick={handleOpenModal} type="button">Upload a Resume</button>
          {onSkip && (
            <>
              <div className="or">or</div>
              <button className="skip_button" onClick={onSkip} type="button">Skip This Step</button>
            </>
          )}
          <UploadResumeModal
            isInJs6650Test
            isOpen={showModal}
            onClose={handleCloseModal}
            onError={handleUploadError}
            onEnd={handleContinue}
            onStart={handleUploadStart}
          />
        </div>
      )}
    </div>
  );
}

UploadResume.propTypes = {
  index: PropTypes.number.isRequired,
  isInJs6650Test: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  setIsLoading: PropTypes.func,
  totalScreeningQuestions: PropTypes.number.isRequired,
};

UploadResume.defaultProps = {
  isInJs6650Test: false,
  onSkip: null,
  setIsLoading: () => {},
};

export default UploadResume;
